import { render, staticRenderFns } from "./StockDirectSaleDialog.vue?vue&type=template&id=5bfd5506"
import script from "./StockDirectSaleDialog.vue?vue&type=script&lang=js"
export * from "./StockDirectSaleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports